import { gql } from '@apollo/client';
import { TRANSLATED_STRING_FIELDS } from '@assets/i18n/config';

export const FETCH_CONFIGURABLE_TABLE_PAGE = gql`
  query fetchConfigurableTablePageName($configurableTablePageId: ObjectID!) {
    fetchConfigurableTablePage(configurableTablePageId: $configurableTablePageId) {
      configurableTablePage {
        name { ${TRANSLATED_STRING_FIELDS} }
      }
    }
  }
`;
